import { Injectable } from '@angular/core';
import { Chart } from 'jscharting';
import { JSCChartConfig } from './jscharting';

@Injectable({
  providedIn: 'root'
})
export class JSChartingService {

  constructor() { }

  chart(config: JSCChartConfig): Chart {
    return new Chart(config);
  }
}